<template>
    <div>
        <the-navbar />
        <v-app-bar app color="primary" dark>
            <v-app-bar-nav-icon
                v-on:click.stop="toggleDrawer"
            ></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <template v-if="null != $store.state.auth.user">
                <v-icon>mdi-account</v-icon>
                <span class="mx-1">{{ $store.state.auth.user.name }}</span>
            </template>
            <v-btn v-on:click="logout" icon class="mx-1">
                <v-icon>mdi-power</v-icon>
            </v-btn>
            <the-progress />
        </v-app-bar>
        <v-main>
            <v-container fluid>
                <router-view />
            </v-container>
        </v-main>
    </div>
</template>

<script>
import snackbar from '@/utils/snackbar';
import { mapMutations } from 'vuex';

export default {
    components: {
        'the-progress': () => import('@/components/TheProgress.vue'),
        'the-navbar': () => import('@/components/TheNavbar.vue')
    },
    data() {
        return {};
    },
    methods: {
        ...mapMutations({
            setDrawer: 'app/SET_DRAWER'
        }),
        async logout() {
            await this.$store.dispatch('auth/logout');
            this.$router.push('/');
            snackbar.show('Logged out');
            this.$log.info('Logged out.');
        },
        toggleDrawer() {
            this.setDrawer(!this.$store.state.app.drawer);
        }
    }
};
</script>
